import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Button from 'shared/components/common/Button/Button.component'
import Modal from 'shared/components/common/Modal/Modal.component'
import Select from 'shared/components/form/Select/Select.component'
import moment from 'moment'

import { createDivAtom } from 'shared/atoms/factory'

import { DateRangePicker } from 'react-dates'
import 'react-dates/initialize'

import styles from './ExportModal.module.scss'

const ButtonsRowWrapper = createDivAtom(),
      SelectRowWrapper = createDivAtom(),
      Title = createDivAtom(),
      Subtitle = createDivAtom(),
      ButtonsWrapper = createDivAtom()

const createDateRange = type => {
  switch(type) {
    case 'Past 30 days': {
      return {
        start: subtractMomentDate(30, 'days'),
        end: moment().format()
      }
    }
    case 'Last Month': {
      return {
        start: subtractMomentDate(1,'months', 'start'),
        end: subtractMomentDate(1,'months', 'end')
      }
    }
    case 'Last Week': {
      return {
        start: subtractMomentDate(1,'isoWeek', 'start'),
        end: subtractMomentDate(1,'isoWeek', 'end')
      }
    }
    default: {
      return {
        start: null,
        end: null
      }
    }
  }
}

const subtractMomentDate = (quantity, time, pivot) =>{
  let date = null

  if(!pivot) date = moment().subtract(quantity, time).format()
  if(pivot === 'start') date = moment().subtract(quantity, time).startOf(time).format()
  if(pivot === 'end') date = makeEndOfDay(moment().subtract(quantity, time).endOf(time)).format()

  return date
}

const makeEndOfDay = momentDate => momentDate.set({
  hour: 23,
  minute: 59,
  second: 59,
  millisecond: 999
})

const ExportModal = ({
  isOpen,
  onToggle,
  onExportV2
}) => {
  const [ focusedInput, updateFocusedInput ] = useState(null)
  const [ startDate, updateStartDate ] = useState(null)
  const [ endDate, updateEndDate ] = useState(null)
  const [ dateRange, updateDateRange ] = useState('')
  const [ fileFormat, updateFileFormat ] = useState('CSV')

  const isExportButtonDisabled = dateRange === 'custom'
    ? !startDate || !endDate
    : !dateRange

  const onDateRangePickerChange = ({ startDate, endDate }) => {
    updateStartDate(startDate)
    updateEndDate(endDate)
  }

  const onExportV2Click = () => {
    const finalDateRange = dateRange === 'custom'
      ? { start: startDate.format(), end: endDate.format() }
      : createDateRange(dateRange)

    onExportV2({
      dateRange: finalDateRange,
      fileFormat
    })
    onToggle()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onToggle}
      size='medium'
    >
      <Title className={styles.title}>
      Export analytics data
      </Title>

      <Subtitle className={styles.subtitle}>
      You will receive an e-mail with a download link once the export has been completed
      </Subtitle>

      <SelectRowWrapper className={styles.selectRowWrapper}>
        <Select
          data={[
            { name: 'Select a date range', code: '' },
            { name: 'Past 30 days', code: 'Past 30 days' },
            { name: 'Last Month', code: 'Last Month' },
            { name: 'Last Week', code: 'Last Week' },
            { name: 'Custom', code: 'custom' }
          ]}
          value={dateRange}
          onChange={e => updateDateRange(e.target.value)}
        />

        {
          dateRange === 'custom' && (
            <DateRangePicker
              startDate={startDate} // momentPropTypes.momentObj or null,
              startDateId="startDate" // PropTypes.string.isRequired,
              endDate={endDate} // momentPropTypes.momentObj or null,
              endDateId="endDate" // PropTypes.string.isRequired,
              onDatesChange={onDateRangePickerChange} // PropTypes.func.isRequired,
              focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
              onFocusChange={focusedInput => updateFocusedInput(focusedInput)}
              small
              isOutsideRange={() => false}
            />
          )
        }
      </SelectRowWrapper>

      <SelectRowWrapper className={styles.selectRowWrapper}>
        <Select
          title='File format'
          data={[
            { name: 'csv', code: 'CSV' },
            { name: 'parquet', code: 'PARQUET' }
          ]}
          value={fileFormat}
          onChange={e => updateFileFormat(e.target.value)}
        />
      </SelectRowWrapper>

      <ButtonsRowWrapper className={styles.buttonsRowWrapper}>
        <Button
          onClick={onToggle}
          title='cancel'
        />

        <ButtonsWrapper className={styles.buttonsWrapper}>
          <Button
            className={styles.ml10}
            primary
            disabled={isExportButtonDisabled}
            onClick={onExportV2Click}
            title='export'
          />
        </ButtonsWrapper>
      </ButtonsRowWrapper>
    </Modal>
  )
}

ExportModal.propTypes = {
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  onExportV2: PropTypes.func
}

export default ExportModal
